import {
  concretiseParams,
  updateSearchParamsWithFilters,
} from "../filters/filters"
import { updateSearchParamsWithPagination } from "../../page"
import { API_BASE_URL } from "../../app/config"
import { getToken, handleSignIn } from "../iam/middleware"

/**
 * Get collections matching the filters
 * @param filers  // filters to apply
 * @param page  // pagination settings
 * @returns {Promise<any>}
 */
export const getCollections = async ({ filter = {}, page = {} }) => {
  // Build parameter set
  const params = new URLSearchParams()
  updateSearchParamsWithFilters(params, filter)
  // Replace any relative ones with absolute ones
  concretiseParams(params)
  // Pagination control
  updateSearchParamsWithPagination(params, page)

  let resp = await fetch(
    `${API_BASE_URL}/api/collections?${params.toString()}`,
    {
      method: "GET",
      mode: "cors",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      redirect: "error",
    }
  )
  resp = handleSignIn(resp)
  return resp.json()
}

/**
 * Get a collection by Id
 * @param observationId
 * @returns {Promise<any>}
 */
export const getCollectionById = async (collectionId) => {
  let resp = await fetch(`${API_BASE_URL}/api/collections/${collectionId}`, {
    method: "GET",
    mode: "cors",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    redirect: "error",
  })

  resp = handleSignIn(resp)
  return resp.json()
}
